// removed by extract-text-webpack-plugin
module.exports = {"LoadingBar":"_3vxGf","shift-rightwards":"_2Q8f9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/LoadingBar/LoadingBar.scss
// module id = 891
// module chunks = 0